export default __webpack_public_path__ + "static/media/withdrawal-transactions.ce337895.svg";